import React, { useState } from "react";
import styles from "./CreateBlogTab.module.scss";
import { createBlogPost } from "../../../../../ApiLayer/admin";
import BlogEditor from "../BlogEditor/BlogEditor";
import MessageComponent from "../../../../../Components/MessageComponent/MessageComponent";

const CreateBlogTab = () => {
  const [message, setMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async ({ title, content, category }) => {
    if (!title.trim()) {
      setMessage("Please enter a title for your blog post");
      return;
    }

    setIsSaving(true);
    try {
      const response = await createBlogPost({
        title: title.trim(),
        content,
        category,
      });

      if (!response.success) {
        setMessage(
          response.message || "Error saving blog post. Please try again."
        );
        return;
      }

      setMessage("Blog post staged successfully!");
    } catch (error) {
      console.error("Error saving blog post:", error);
      setMessage("Error saving blog post. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <div className={styles.tabContent}>
        <MessageComponent message={message} />
      </div>
      <BlogEditor 
        onSave={handleSave} 
        isSaving={isSaving}
        buttonText="Stage Post"
      />
    </>
  );
};

export default CreateBlogTab;
